<!-- 采购订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo1" class="baseForm1" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row>
                                            <el-form-item label="终端客户" prop="tcmName" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('终端客户')" v-html="$common.htmlLabel('终端客户')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.tcmName" @keyup.enter.native="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId,ormId')">
                                                    <el-button @click="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId,ormId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="客户名称" prop="cmName" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('客户名称')" v-html="$common.htmlLabel('客户名称')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.cmName" @keyup.enter.native="openSearch(3391151360249856, 0, 'cmName', 'cmName,cmId')">
                                                    <el-button @click="openSearch(3391151360249856, 0, 'cmName', 'cmName,cmId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="供应商" prop="smName" :rules="sendDataInfo.isStart==1?[]:[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('供应商')" v-html="$common.htmlLabel('供应商')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.smName" @keyup.enter.native="openSearch(3386264207560704, 0, 'smName', 'smName,smId')">
                                                    <el-button @click="openSearch(3386264207560704, 0, 'smName', 'smName,smId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="是否起始节点" prop="isStart" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('是否起始节点')" v-html="$common.htmlLabel('是否起始节点')+':'"></label>
                                                <el-radio-group class="label_input" v-model="sendDataInfo.isStart">
                                                    <el-radio-button :label="1">是</el-radio-button>
                                                    <el-radio-button :label="0">否</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item label="是否末尾节点" prop="isEnd" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('是否末尾节点')" v-html="$common.htmlLabel('是否末尾节点')+':'"></label>
                                                <el-radio-group class="label_input" v-model="sendDataInfo.isEnd" @input="isEndChange">
                                                    <el-radio-button :label="1">是</el-radio-button>
                                                    <el-radio-button :label="0">否</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item label="线路等级" prop="level" :rules="[{ required: true,  trigger: ['blur', 'change'] }, { validator: validateLevel, trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('线路等级')" v-html="$common.htmlLabel('线路等级')+':'"></label>
                                                <el-select class="label_input" v-model="sendDataInfo.level" clearable placeholder="请选择">
                                                    <el-option
                                                        v-for="item in levelOptions"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="结算比例(0~1)" prop="settleRate"  :rules="[{ required: true,  trigger: ['blur', 'change'] }, { validator: validateSettleRate, trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('结算比例(0~1)')" v-html="$common.htmlLabel('结算比例(0~1)')+':'"></label>
                                                <el-input class="label_input" :disabled="sendDataInfo.isEnd==1?true:false" @mousewheel.native.prevent type="number" v-model="sendDataInfo.settleRate" clearable></el-input>
                                            </el-form-item>
                                            <el-form-item label="出库业务员" prop="suOpmName" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('出库业务员')" v-html="$common.htmlLabel('出库业务员')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.suOpmName" @keyup.enter.native="openSearch(4444770562019328, 0, 'suOpmName', 'suOpmName,suOpmId')">
                                                    <el-button @click="openSearch(4444770562019328, 0, 'suOpmName', 'suOpmName,suOpmId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="出库货主" prop="suCoName" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('出库货主')" v-html="$common.htmlLabel('出库货主')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.suCoName" @keyup.enter.native="openSearch(4414428383875072, 0, 'suCoName', 'suCoName,suCoId')">
                                                    <el-button @click="openSearch(4414428383875072, 0, 'suCoName', 'suCoName,suCoId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="出库地址" prop="suCaiName" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('出库地址')" v-html="$common.htmlLabel('出库地址')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.suCaiName" @keyup.enter.native="openSearch(423073365168128, 0, 'suCaiName', 'suCaiName,suCaiId')">
                                                    <el-button @click="openSearch(423073365168128, 0, 'suCaiName', 'suCaiName,suCaiId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="出库复核员" prop="suWorcmCheckName" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('出库复核员')" v-html="$common.htmlLabel('出库复核员')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.suWorcmCheckName"
                                                          @keyup.enter.native="openSearch(4444770562019328, 0, 'suWorcmCheckName', 'suWorcmCheckName,suWorcmCheck')">
                                                    <el-button @click="openSearch(4444770562019328, 0, 'suWorcmCheckName', 'suWorcmCheckName,suWorcmCheck')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="入库业务员" prop="puOpmName" :rules="sendDataInfo.isStart==1?[]:[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('入库业务员')" v-html="$common.htmlLabel('入库业务员')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.puOpmName" @keyup.enter.native="openSearch(4444770562019328, 0, 'puOpmName', 'puOpmName,puOpmId')">
                                                    <el-button @click="openSearch(4444770562019328, 0, 'puOpmName', 'puOpmName,puOpmId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="入库货主" prop="puCoName" :rules="sendDataInfo.isStart==1?[]:[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('入库货主')" v-html="$common.htmlLabel('入库货主')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.puCoName" @keyup.enter.native="openSearch(4414428383875072, 0, 'puCoName', 'puCoName,puCoId')">
                                                    <el-button @click="openSearch(4414428383875072, 0, 'puCoName', 'puCoName,puCoId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="入库收货人" prop="puRegoName" :rules="sendDataInfo.isStart==1?[]:[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('入库收货人')" v-html="$common.htmlLabel('入库收货人')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.puRegoName" @keyup.enter.native="openSearch(4444770562019328, 0, 'puRegoName', 'puRegoName,puRegoId')">
                                                    <el-button @click="openSearch(4444770562019328, 0, 'puRegoName', 'puRegoName,puRegoId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="入库验收人" prop="puPschaName" :rules="sendDataInfo.isStart==1?[]:[{ required: true,  trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('入库验收人')" v-html="$common.htmlLabel('入库验收人')+':'"></label>
                                                <el-input class="label_input" clearable v-model="sendDataInfo.puPschaName" @keyup.enter.native="openSearch(4444770562019328, 0, 'puPschaName', 'puPschaName,puPschaId')">
                                                    <el-button @click="openSearch(4444770562019328, 0, 'puPschaName', 'puPschaName,puPschaId')" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <!-- <el-form-item label="排序" prop="sort">
                                                <label slot="label" :style="$common.labelStyle('排序')" v-html="$common.htmlLabel('排序')+':'"></label>
                                                <el-input class="label_input" @mousewheel.native.prevent type="number" v-model.number="sendDataInfo.sort" clearable></el-input>
                                            </el-form-item> -->
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <historicalOrders ref="HistoricalOrders" />
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "terminalLineAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            mxHeight: 0,
            dataActionBox: {
                showStatus: false,
                actionType: 0, // 0新增，1修改
            },
            showTabs: "手术包表单",
            tabForm: [
                {
                    jciName: "手术包表单",
                    jurconfigform: [],
                }
            ], // tab循环的主表单
            footForm: [],
            sendDataInfo: {
                ormId: "",
                cmId: "",
                cmName: "",
                isEnd: 0,
                isStart: 0,
                level: 1,
                lineId: "",
                settleRate: "",
                smId: "",
                smName: "",
                sort: "",
                tcmId: "",
                tcmName: "",
                suOpmName: "",
                suOpmId: "",
                suCoName: "",
                suCoId: "",
                suCaiName: "",
                suCaiId: "",
                suWorcmCheckName: "",
                suWorcmCheck: "",
                puOpmName: "",
                puOpmId: "",
                puCoName: "",
                puCoId: "",
                puRegoName: "",
                puRegoId: "",
                puPschaName: "",
                puPschaId: "",
            },
            levelOptions: [
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' }
            ],
            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            smId: "",
            parentSearchData: {},
            isLoaded: false,
            seIndex: 0, //选中索引
            sField: "", // 赋值字段
            fField: "", //焦点字段
            typeList: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.isEnd": {
            handler: function (newValue, oldValue) {
                if (newValue == 1) {
                    this.sendDataInfo.isStart = 0;
                }
            },
            deep: true
        },
        "sendDataInfo.isStart": {
            handler: function (newValue, oldValue) {
                if (newValue == 1) {
                    this.sendDataInfo.isEnd = 0;
                }
            },
            deep: true
        },
        "sendDataInfo.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.smId = "";
                    this.sendDataInfo.puOpmName = "";
                    this.sendDataInfo.puOpmId = "";
                    this.sendDataInfo.puCoName = "";
                    this.sendDataInfo.puCoId = "";
                    this.sendDataInfo.puRegoName = "";
                    this.sendDataInfo.puRegoId = "";
                    this.sendDataInfo.puPschaName = "";
                    this.sendDataInfo.puPschaId = "";
                }
            },
            deep: true
        },
        "sendDataInfo.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.cmId = "";
                    this.sendDataInfo.suOpmName = "";
                    this.sendDataInfo.suOpmId = "";
                    this.sendDataInfo.suCoName = "";
                    this.sendDataInfo.suCoId = "";
                    this.sendDataInfo.suCaiName = "";
                    this.sendDataInfo.suCaiId = "";
                    this.sendDataInfo.suWorcmCheck = "";
                    this.sendDataInfo.suWorcmCheckName = "";
                }
            },
            deep: true
        },
        "sendDataInfo": {
            handler: function (newValue, oldValue) {
                if (newValue.suCoName == "") {
                    this.sendDataInfo.suCoId = "";
                }
                if (newValue.suCaiName == "") {
                    this.sendDataInfo.suCaiId = "";
                }
                if (newValue.suOpmName == "") {
                    this.sendDataInfo.suOpmId = "";
                }
                if (newValue.suWorcmCheckName == "") {
                    this.sendDataInfo.suWorcmCheck = "";
                }
                if (newValue.puOpmName == "") {
                    this.sendDataInfo.puOpmId = "";
                }
                if (newValue.puCoName == "") {
                    this.sendDataInfo.puCoId = "";
                }
                if (newValue.puRegoName == "") {
                    this.sendDataInfo.puRegoId = "";
                }
                if (newValue.puPschaName == "") {
                    this.sendDataInfo.puPschaId = "";
                }
            },
            deep: true
        }
    },
    //方法集合
    methods: {
        isEndChange() {
            if (this.sendDataInfo.isEnd == 1) {
                this.sendDataInfo.settleRate =1;
            }
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                console.log("选中的数据", this.actionData);
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        toDetail(orderId) {
            this.$parent.$parent.$parent.toDetail(orderId);
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        //提取返回
        changeInputModel(val) {
            console.log("返回", val, this.seType);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'suOpmName') {
                    this.sendDataInfo.suOpmName = val.opmName;
                    this.sendDataInfo.suOpmId = val.opmId;
                } else if (this.seType == 'suCoName') {
                    this.sendDataInfo.suCoName = val.coName;
                    this.sendDataInfo.suCoId = val.coId;
                } else if (this.seType == 'suCaiName') {
                    this.sendDataInfo.suCaiName = val.caiAddress;
                    this.sendDataInfo.suCaiId = val.caiId;
                } else if (this.seType == 'suWorcmCheckName') {
                    this.sendDataInfo.suWorcmCheckName = val.opmName;
                    this.sendDataInfo.suWorcmCheck = val.opmId;
                } else if (this.seType == 'puCoName') {
                    this.sendDataInfo.puCoName = val.coName;
                    this.sendDataInfo.puCoId = val.coId;
                } else if (this.seType == 'puRegoName') {
                    this.sendDataInfo.puRegoName = val.regoName;
                    this.sendDataInfo.puRegoId = val.regoId;
                } else if (this.seType == 'puPschaName') {
                    this.sendDataInfo.puPschaName = val.pschaName;
                    this.sendDataInfo.puPschaId = val.pschaId;
                } else if (this.seType == 'puOpmName') {
                    this.sendDataInfo.puOpmName = val.opmName;
                    this.sendDataInfo.puOpmId = val.opmId;
                } else {
                    this.paramValue(val)
                }
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField) {
            this.parentSearchData = {}
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.parentSearchData[type] = this.sendDataInfo[type];
            // console.log(this.seType,cmName ,'seTypeseType');
            if (this.seType == "cmName") { 
                if (this.sendDataInfo.ormId == "") {
                    return this.$message.error("请先选择终端客户！");
                }
            }
            if (this.seType == "suOpmName" || this.seType == "suCoName" || this.seType == "suCaiName" || this.seType == "suWorcmCheck") {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message.error("请先选择客户名称！");
                }
            }
            if (this.seType == "puOpmName" || this.seType == "puCoName" || this.seType == "puRegoName" || this.seType == "puPschaName") {
                if (this.sendDataInfo.smId == "") {
                    return this.$message.error("请先选择供应商名称！");
                }
            }
            this.parentSearchData.ormId = this.sendDataInfo.ormId;
            this.DialogVisible = true;
            if (this.seType == 'suWorcmCheck') {//出库复核员
                this.parentSearchData.opmReviewer = 1
            } else if (this.seType == 'suOpmName') {//出库业务员
                this.parentSearchData.opmSalesperson = 1
            } else if (this.seType == 'puRegoName') {//入库收货人
                this.parentSearchData.opmDelivery = 1
            } else if (this.seType == 'puOpmName') {//入库业务员
                this.parentSearchData.opmBuyer = 1
            } else if (this.seType == 'puPschaName') {//入库验收人
                this.parentSearchData.opmAcceptor = 1
            } else if (this.seType == 'suCaiName') {//出库地址
                this.parentSearchData.cmId = this.sendDataInfo.cmId
            }
            
        },
        initActionBox(sendDataInfo) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    this.init();
                    this.$refs[sendDataInfo].resetFields();
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'isEnd' || key == 'isStart') {
                    this.sendDataInfo[key] = 0;
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            var oldData = this.actionData.oldData;
            if (this.dataActionBox.actionType == 0) {
                this.init()
            } else if (this.dataActionBox.actionType == 1) {
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.sendDataInfo.surgeryType = Number(this.sendDataInfo.surgeryType)
            } else {
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                this.sendDataInfo.surgeryType = Number(this.sendDataInfo.surgeryType)
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                }, 16.7);
            });
        },
        //确认
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub()
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });

        },
        validateSettleRate(rule, value, callback) {
            if (value !== '' && value !== null && value !== undefined) {
                const numValue = Number(value);
                if (numValue < 0 || numValue > 1) {
                    callback(new Error('结算比例必须大于等于0且小于等于1'));
                } else {
                    callback();
                }
            } else {
                callback(new Error('请输入结算比例'));
            }
        },
        validateLevel(rule, value, callback) {
            if (value !== '' && value !== null && value !== undefined) {
                const numValue = Number(value);
                if (!Number.isInteger(numValue) || numValue <= 0) {
                    callback(new Error('线路等级必须为正整数'));
                } else {
                    callback();
                }
            } else {
                callback(new Error('请输入线路等级'));
            }
        },
        async sub() {
            var sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            console.log(this.sendDataInfo);

            sendData.lineId = this.actionData.orderId
            var responseData
            if (this.dataActionBox.actionType == 1) {
                responseData = await this.$http.lineDetailmodify(sendData);
            } else {
                responseData = await this.$http.lineDetailadd(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getType() {
            const res = await this.$http.dictSurgeryqueryList({ surgeryName: "" })
            if (res.status == 200) {
                this.typeList = res.result
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.getType()
            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        };
    },
    beforeDestroy() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}

::v-deep .el-alert__content {
    width: 100%;
}
.label_input {
    width: 230px !important;
}
</style>